import { useTheme } from '@mui/material/styles'
import { useEffect, useState, useContext, useRef } from 'react'
import { Stack, Box, Typography, List, ListItem } from '@mui/material'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import Logo from '../../assets/logo'

export const Faq = ({}) => {
  const theme = useTheme()
  const Navigate = useNavigate()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <Stack
      sx={{ width: '100vw', minHeight: '100vh', marginBottom: '200px' }}
      alignItems={'center'}
    >
      <Stack
        sx={{ width: '100vw', height: '200px' }}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Logo width={200} />
      </Stack>
      <Stack
        direction={'column'}
        sx={{ maxWidth: 600, justifyContent: 'center' }}
      >
        <motion.div style={{ fontSize: 16, fontWeight: 300, marginBottom: 20 }}>
          Welcome to JoinU for the Harvard community
        </motion.div>
        {[
          {
            q: 'What is JoinU for the Harvard community?',
            a: 'JoinU for Harvard is an implementation of the JoinU application for use at Harvard University, designed to help you cultivate community during your time at Harvard. You’ll discover fun, exciting, and new opportunities to be socially active. What do you like to do or want to try? With friends? Where? Do this and more with JoinU. It works on mobile devices (iOS and Android) along with internet browsers.',
          },
          {
            q: 'What can I do on JoinU for the Harvard community?',
            a: '',
            b: [
              'Find out about upcoming events you’re interested in like yoga, board games, and lectures, and join events happening within your Harvard communities, like your class, dorm, department, or office.',
              'Spend more time doing things you enjoy. Organize your own activities and events for you, your friends, and your Harvard communities.',
              'Invite your friends and coworkers to events and activities you’re interested in joining.',
              'Browse and join events happening in your Harvard communities and across all campuses.',
              'Never miss an event again with automatic email, SMS, and/or calendar reminders.',
              'Create your own invite-only friend groups to plan events and activities you’re interested in.',
              'See how a robust and more connected community helps you be more active. Set goals for and track your movement progress.',
            ],
            p: [
              'We are continually working to improve the JoinU for Harvard University experience and are always interested in hearing feedback.',
              ' ',
            ],
          },
          {
            q: 'What types of activities are available on the app?',
            a: 'JoinU covers all types of activities including formal Harvard events (e.g., House social events, special lectures/presentation, IM sports, etc.) and informal events (e.g., dinner with blocking group, coffee break, and study sessions). With a flexible tagging system, users can create and search groups/events based on anything (activity type, location, disability accommodations, etc.).',
          },
          {
            q: 'Who can use the JoinU app for Harvard?',
            a: 'Any Harvard affiliate with a HarvardKey can download and use the JoinU app for Harvard University. This includes undergraduate students, graduate students, faculty, and staff members.',
          },
          {
            q: 'What kinds of information does JoinU for the Harvard community collect?',
            a: 'Currently, no extra information or data is stored beyond user account details. JoinU uses that information to enhance user experiences.',
          },
          {
            q: 'How is it different from other networking/communication apps?',
            a: 'JoinU for the Harvard community has been designed specifically for the Harvard community by the Harvard community. Instead of doom scrolling through an infinite feed that gives you FOMO ("fear of missing out"), JoinU helps you find and build healthy communities and connections in real life. JoinU for Harvard integrates with Harvard-specific resources, facilities, and organizational structures. It does this while adding little to no overhead for administrative users and provides an intuitive, easy to use, experience for users.',
          },
          {
            q: 'Is my data private and safe?',
            a: 'All information JoinU collects will be stored in strict compliance for privacy as outlined in the MyDataCan privacy policy and the JoinU for Harvard privacy addendum with full user transparency and control. The MyDataCan dashboard describes all the JoinU data stored in a user’s DataCan, and through the dashboard users can view, download, delete, privatize/encrypt (restrict access only to user), assign access privileges, and approve sharing.',
          },
        ].map((d, i) => (
          <motion.div style={{ fontSize: 18, marginBottom: 5 }}>
            <motion.div
              style={{ fontSize: 18, fontWeight: 500, marginBottom: 5 }}
            >
              {d.q}
            </motion.div>
            <motion.div
              style={{ fontSize: 18, fontWeight: 400, marginBottom: 5 }}
            >
              {d.a}
            </motion.div>

            <List
              sx={{
                listStyleType: 'disc',
                pl: 2,
                '& .MuiListItem-root': {
                  display: 'list-item',
                },
              }}
            >
              {d.b?.map((e) => (
                <ListItem>{e}</ListItem>
              ))}
            </List>

            {d.p?.map((e) => (
              <p style={{ fontSize: 18, fontWeight: 400, marginBottom: 5 }}>
                {e}
              </p>
            ))}
          </motion.div>
        ))}
        <motion.div style={{ fontSize: 18, fontWeight: 500, marginBottom: 5, marginTop: 30 }}>
          Where can I learn more about JoinU and other participating universities?
        </motion.div>
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 20 }}>
          Visit {' '}
          <a href='https://joinu.org/'>joinu.org.</a>
        </motion.div>
        <motion.div style={{ fontSize: 18, fontWeight: 500, marginBottom: 5, marginTop: 20 }}>
          Where can I learn more about the backstory of JoinU?
        </motion.div>
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 30 }}>
          Learn more about the creation and history of JoinU{' '}
          <a href='https://joinu.org/history'>on the JoinU History page (joinu.org/history).</a>
        </motion.div>
        <motion.div style={{ fontSize: 18, fontWeight: 500, marginBottom: 5, marginTop: 20 }}>
          How can I advertise on JoinU?
        </motion.div>
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 30 }}>
        Discover how JoinU can boost your business or event's visibility by visiting {' '}
          <a href='https://harvard.joinu.org/sponsors'>the JoinU Sponsors page (harvard.joinu.org/sponsors).</a>
        </motion.div>
      </Stack>
    </Stack>
  )
}
